module.exports = __webpack_public_path__ + "static/media/chip.22fd021b.svg";